import { CommonModule } from "@angular/common";
import { Component, Input, Output, EventEmitter } from "@angular/core";
import { IPermission } from "../../../permissions/dtos/responses/permission.response";
import { IPermissionGroup } from "../../models/permission-group.model";

@Component({
  selector: 'app-permission-group',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './permission-group.component.html',
  styleUrls: ['./permission-group.component.scss'],
})
export class PermissionGroupComponent {
  @Input() group!: IPermissionGroup;
  @Input() isSelected: (id: string) => boolean = () => false;

  @Output() toggleGroup = new EventEmitter<IPermissionGroup>();
  @Output() togglePermission = new EventEmitter<IPermission>();

  onGroupToggle() {
    this.toggleGroup.emit(this.group);
  }

  onPermissionToggle(permission: IPermission) {
    this.togglePermission.emit(permission);
  }
}
